export default function DeliveryModelStep({ onNext, onBack }) {
  return (
    <>
      <h3>Delivery & Pricing</h3>

      <label>Reporting Frequency</label>
      <select>
        <option>Monthly</option>
        <option>As Requested</option>
      </select>

      <label>Proposed Start Date</label>
      <input type="date" />

      <label>Support Model</label>
      <select>
        <option>Fixed Price / Subscription</option>
        <option>Time & Materials</option>
      </select>

      <div className="actions">
        <button className="btn secondary" onClick={onBack}>Back</button>
        <button className="btn primary" onClick={onNext}>Next</button>
      </div>
    </>
  );
}
